import React, {useState} from 'react';

import {ChatRoomsEnum} from 'presentation/constants';
import {GynecologistEnum} from 'presentation/modules/booking/shared/constants/beBornWell';
import {useCallChatRoom, useMediaQueries} from 'presentation/pages/private/hooks';
import {Specialty} from 'presentation/utils';
import {UseSpecialtyNotAvailableBeBornCardProps} from './types';

export function useSpecialtyNotAvailableBeBornCard({
	handleCheckDuplicity,
	handleSelectCard,
}: UseSpecialtyNotAvailableBeBornCardProps) {
	const {isMobile} = useMediaQueries();

	const {callChatRoom, IS_LOADING: callChatRoomIsLoading} = useCallChatRoom();
	const handleCallChatRoom = async () => {
		await callChatRoom(ChatRoomsEnum.APP);
	};
	const [openPhoneDrawerState, setOpenPhoneDrawerState] = useState<boolean>(false);
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

	const isPhoneNumberMenuOpen = Boolean(anchorEl);

	const handleOpenPhoneMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
		if (isMobile) {
			setOpenPhoneDrawerState(true);
			return;
		}
		setAnchorEl(event.currentTarget);
	};

	const handleTogglePhoneDrawer = () => {
		setOpenPhoneDrawerState(prev => !prev);
	};

	const handleClosePhoneMenu = () => {
		setAnchorEl(null);
	};

	const handleGynecologyClick = async () => {
		const alreadyScheduled = await handleCheckDuplicity(GynecologistEnum.CODE);

		if (!alreadyScheduled) {
			const specialty: Specialty = {
				code: GynecologistEnum.CODE,
				description: GynecologistEnum.CLINICAL_GYNECOLOGY,
				formattedText: GynecologistEnum.CLINICAL_GYNECOLOGY,
				telemedicine: '',
			};
			await handleSelectCard(specialty);
		}
	};

	return {
		handleCallChatRoom,
		openPhoneDrawerState,
		handleTogglePhoneDrawer,
		isPhoneNumberMenuOpen,
		anchorEl,
		handleOpenPhoneMenu,
		handleClosePhoneMenu,
		handleGynecologyClick,
		isMobile,
		callChatRoomIsLoading,
	};
}
